import Vue from 'vue'
import { CHALLENGES_REQUEST } from '../actions/challenges'
import api from '@/services/Api';

// ----------------------------- o

const state = {
    year: [],
    month: [],
    quarter: [],
    quarterDetails: [],
    summaryMonths: [],
    summaryQuarters: [],
    summaryMonthlyBonus: [],
    summaryQuarterlyBonus: [],
    totalBonus: 0,
    aboveTarget: false
};

// ----------------------------- o

const getters = {
    getYears: state => state.year,
    getCurrentMonth: state => state.month,
    getCurrentQuarter: state => state.quarter,
    getQuarterDetails: state => state.quarterDetails,
    getSummaryMonths: state => state.summaryMonths,
    getSummaryQuarters: state => state.summaryQuarters,
    getSummaryMonthlyBonus: state => state.summaryMonthlyBonus,
    getSummaryQuarterlyBonus: state => state.summaryQuarterlyBonus,
    getSummaryTotalBonus: state => state.totalBonus,
    getAboveTarget: state => state.aboveTarget
};

// ----------------------------- o

const actions = {
    [CHALLENGES_REQUEST]: ({commit, dispatch, rootState}) => {
        return new Promise((resolve, reject) => {

            // get challenges
            api.get(rootState.user.currentPlace ? '/api/v1/challenges?customerNumber=' + rootState.user.currentPlace + '&year=' + rootState.user.currentYear : '/api/v1/challenges' + '?year=' + rootState.user.currentYear).then(resp => {
                commit(CHALLENGES_REQUEST, resp.data.data);
                resolve(resp)
            }).catch(err => {
                reject(err)
            })

        });
    }
};

const mutations = {
    [CHALLENGES_REQUEST]: (state, resp) => {
        state.year = resp.year || [];
        state.month = resp.currentMonthPlan || [];
        state.quarter = resp.currentQuarterPlan || [];
        state.quarterDetails = resp.currentQuarterPlanDetails || [];
        state.summaryMonths = resp.monthsPlan || [];
        state.summaryQuarters = resp.quartersPlan || [];
        state.summaryMonthlyBonus = resp.bonusMonthsPlan || [];
        state.summaryQuarterlyBonus = resp.bonusQuartersPlan || [];
        state.totalBonus = resp.totalBonus || 0;
        state.aboveTarget = resp.aboveTarget || false;
    }
};

// ----------------------------- o

export default {
    state,
    getters,
    actions,
    mutations
}